/**
 * EGDE Scroll Fade-In
 * Adds .is-visible class to sections when they enter viewport.
 * translateY(16px) → 0, opacity 0 → 1, duration 0.7s (defined in base.css)
 */
(function () {
  const targets = document.querySelectorAll(
    '.section-resource-list, .egde-fade-in'
  );

  if (!targets.length) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();
